
import vFooter from '../../common/footer.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import {getMemberAsset,putForward,getMemberPoint} from '@/base/js/api'
export default {
name: 'app',
data() {
return {
tabIndex: 1,
show: false,
show1: false,
isMask: false,
tabNum:0,
userInfo:'',
wxInfo:'',
asset:'',
memberPoint:'--',
miniprogram:localStorage.getItem("miniprogram")
}
},
components: {
vFooter,
Actionsheet,
PopupPicker
},
created(){
this._wxTool.auth();
this.wxInfo = this._wxTool.getUser();
this.userInfo = this._wxTool.getMember();
if(null==this.userInfo ){
console.log('need login');
this.$router.push('login')
}
this._wxTool.setShare('','https://wx2.yutong.com/tgds/');

let params ={
accessToken : this._wxTool.getAccessToken()
}
getMemberAsset(params).then(res=>{
if(res.code == 0){
console.log(res);
this.asset = res.data.asset

}else{
this.$vux.toast.text(res.msg, 'middle')
}
})
getMemberPoint(params).then(res=>{
if(res.code == 0){
console.log(res);
this.memberPoint = res.data.memberPoint
}else{
this.$vux.toast.text(res.msg, 'middle');
this.noMore = true
}
})
},
beforeRouteLeave(to,from,next){
if(to.name=='fenxiang'){
to.meta.keepAlive=false
}
next()
},
methods: {
tab(e) {
let tabIndex = e;
if (tabIndex == this.tabIndex) {
if (tabIndex == 1) {
this.show = !this.show
this.isMask = !this.isMask
this.tabIndex = tabIndex
} else {
this.show1 = !this.show1
this.isMask = !this.isMask
this.tabIndex = tabIndex
}
return
}
this.tabIndex =  tabIndex
this.isMask = false
this.show = false
this.show1 = false
},
}
}



// WEBPACK FOOTER //
// ./src/pages/my/index/index.vue